import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
interface IFooterProps {
    refetch: () => void
}
export default function Footer({ refetch }: IFooterProps) {
    const { moneyPool } = useParams()
    const navigate = useNavigate()
    const { state } = useLocation()

    return (
        <div className=" absolute bottom-0 w-full border-t border-gray-5">
            <div className=" w-full text-center flex justify-center">
                <p
                    className=" text-error-3 py-4  "
                    onClick={() =>
                        navigate(`/fund/settlement-exit/add/${moneyPool}`, {
                            state: {
                                poolShipId: state.poolShipId,
                            },
                        })
                    }
                >
                    درخواست تسویه و خروج
                </p>
            </div>
        </div>
    )
}
